import { CollideEvent, CollideId } from '../../defs/collide';
import { BubblesBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BubblesEffect } from '../effects/BubblesEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

/*
    bubbles block collision resolver
*/
export class BubblesCollision implements ICollision {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _entity: BubblesBlockEntity;
  // map
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this._resolveTap,
    block: this._resolveBlock,
    attack: this._resolveAttack,
  };

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, entity: BubblesBlockEntity) {
    this._scene = scene;
    this._entity = entity;
  }

  // impl
  //-------------------------------------------------------------------------
  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  // private: resolvers
  //-------------------------------------------------------------------------
  private async _resolveTap() {
    await new InvalidEffect(this._entity).execute();
    return false;
  }

  private async _resolveBlock() {
    await this._attack();
    return true;
  }

  private async _resolveAttack() {
    await this._attack();
    return true;
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _attack() {
    await new BubblesEffect(this._scene, {
      subject: this._entity,
    }).execute();
  }
}
